import { postMediaUrl } from '@/api/mediaAPI'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { useQuery } from '@tanstack/react-query'

function DirectDownload({
  path,
  sizeClass,
}: {
  path: string
  sizeClass?: string
}) {
  const { data } = useQuery({
    queryKey: ['media_url', path],
    queryFn: () =>
      postMediaUrl({
        key: path,
        isPrivate: 'true',
      }),
    staleTime: 5 * 60 * 1000,
  })

  return (
    <div className={'p-2'}>
      <a href={data} rel="noreferrer" target="_BLANK">
        <ArrowDownTrayIcon className={sizeClass || 'h-4 w-4 text-black'} />
      </a>
    </div>
  )
}

export default DirectDownload
